import { usersApiPaths } from '@/hooks/api/_paths'
import type { ConsentSettings, ConsentSettingsPolicyData } from '@/hooks/api/_types'
import { useApiRequest } from '@/lib/http-utils'
import { useQuery } from '@tanstack/react-query'

function useConsentSettingsQuery() {
  const { apiRequest } = useApiRequest()
  return useQuery({
    staleTime: Infinity,
    queryKey: consentSettingsKey,
    queryFn: async (): Promise<ConsentSettings> => {
      const response = await apiRequest({ path: usersApiPaths.privacyPreferences })

      if (response.status !== 200) {
        throw new Error('FAILED_TO_GET_CONSENT_SETTINGS')
      }

      const data = (await response.json()) as ConsentSettingsPolicyData

      return adapt(data)
    },
  })
}

const consentSettingsKey = ['consent-settings']

// 👇 data adapters

const adapt = (data: ConsentSettingsPolicyData): ConsentSettings => ({
  allowData: !!data.policies.find(({ name }) => name === 'ALLOW_DATA')?.preference,
  allowMarketing: !!data.policies.find(({ name }) => name === 'ALLOW_MARKETING_COMMS')?.preference,
})

export { consentSettingsKey, useConsentSettingsQuery }
